<template>
    <div class="client-row">
        <label for="currentTimePeriod" class="col-3">Roadmap Initiative Set</label>
        <div class="col-9 d-flex pl-0">
          <div class="col-3 m-0 p-0 d-flex">
            <select id="sectorId" name="sectorId" v-model="sectorId" class="form-control w-100" @change="saveRoadmapInitiative">
                <option v-for="(sector_option, idxSectorOptions) in sector_options" v-bind:value="sector_option.sectorId" v-bind:key="idxSectorOptions">
                    {{ sector_option.name }}
                </option>
            </select>
          </div>
          <div class="col-6 ml-1">
              <button type="button" class="btn btn-primary" :disabled="this.inputClientCode == '' || !isEditMode" @click="openApplyToClientHierarchy">Apply to Client Hierarchy</button>
          </div>
        </div>
        <modal
            :modal-id="'Apply to Client Hierarchy For Roadmap Initiative'"
            :modal-title="'Apply to Client Hierarchy'"
            :modal-content="'Are you sure you want apply the Roadmap Initiative to all organizations in this hierarchy ?'"
            :include-confirmation="true"
            @confirm="applyRoadmapInitiativeToHierarchy"
          />
    </div>  

</template>
<script>
import ClientService from "../services/client.service";
import AdminService  from "../services/admin.service";
import ViewMixins from "../mixins/ViewMixins.vue";
export default {
  name: "RoadmapInitiative",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
        // localValue: 0,
        applyToHierarchy: 'N',
        sectorId: 0,
        sector_options: []
    };
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    },
    inputClientCode: {
        type: String,
        default: ""
    },      
    inputSectorOptions: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: 0
    },
  },
  computed: {
    
  },
  mounted() {
    
  },
  created() {
    this.sector_options = this.inputSectorOptions;
    // default "Generic"
    if (this.value == 0) {
        const genericSector = this.sector_options.find(item => item.name.toLowerCase() === 'generic');
        if (genericSector) {
            this.sectorId = genericSector.sectorId;
        }
    } else {
        this.sectorId = this.value;
    }
  },
  methods: {
    openApplyToClientHierarchy: function(){
        this.applyToHierarchy = 'Y';
        this.$modal.show("Apply to Client Hierarchy For Roadmap Initiative");
    },
    applyRoadmapInitiativeToHierarchy: function(){
        this.applyToHierarchy = 'Y';
        this.saveRoadmapInitiative(true);
    },
    saveRoadmapInitiative(withHierarchy = false) {
        if(!this.isEditMode) {
            return;
        }
        if (withHierarchy === true) {
            this.$root.processServerRequest("Saving roadmap initiative for hierarchy");        
        } else {
           this.$root.processServerRequest("Saving roadmap initiative");
        }
        ClientService.saveRoadmapInitiative(this.inputClientCode, this.sectorId, this.applyToHierarchy, this.saveRoadmapInitiativeCallback, this)
    },
    saveRoadmapInitiativeCallback(response) {
        this.$root.processServerResponse();
        if (response.data.statusCode == 200) {
            AdminService.displaySuccessMessage({ text: response.data.message });
        } else {
            AdminService.displayErrorMessage({ text: response.data.message });
        }
        this.applyToHierarchy = 'N';
    },
    normalize(val) {
        return val === null || val === undefined ? 0 : Number(val);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.sectorId = this.normalize(val);
      }
    },
    sectorId(val) {
      this.$emit("input", this.normalize(val));
    }
  },
};
</script>
